import { BlurEvent, ChangeEvent } from "@mcleod/components";
import { AutogenLayoutOpportunityFindNear } from "./autogen/AutogenLayoutOpportunityFindNear";
import { ModelProspect } from "./models/ModelProspect";
import { CityUtil, ModelRow } from "@mcleod/core";

export class OpportunityFindNear extends AutogenLayoutOpportunityFindNear {
    PLOT_SETTING = "lme/dispatch/LocationFindNear.checkPlotOnMap.checked";
    private _customerId: string;

    override onLoad() {
        this.textboxStatus.setSelectedItemFromValue("P");
    }

    switchPlotOnMapOnChange(event: ChangeEvent) {
        const shouldPlot = this.switchPlotOnMap.checked;
        this.mapFindNear.visible = shouldPlot;
        this.mapFindNear.dataSource = shouldPlot ? this.sourceOpportunity : null;
        if (event.userInitiatedChange) {
            this.splitterMap.position = shouldPlot ? "50%" : "100%";
            this.splitterMap.storeUserChoiceIfRemembered();
        }
        if (shouldPlot)
            this.sourceOpportunity.displayDataInBoundComponents();
    }

    get customerId(): string {
        return this._customerId;
    }

    set customerId(value: string) {
        this._customerId = value;
        new ModelProspect().searchSingle({ id: value }).then(prospect => {
            if (prospect && !prospect.isNull("city_id")) {
                const useBase = prospect.isNull("search_city") 
                            || prospect.isNull("search_state_id") 
                            || prospect.isNull("search_zip_code");
                const lmData = new ModelRow(this.citystateNear.textCombined.lookupModel, false, {
                    "id": prospect.get("city_id", null),
                    "name": useBase ? prospect.getString("city") : prospect.getString("search_city"),
                    "state_id": useBase ? prospect.getString("state_id") : prospect.getString("search_state_id"),
                    "zip_code": useBase ? prospect.getString("zip_code") : prospect.getString("search_zip_code")
                });
                this.citystateNear.boundRow.setValueAndLookupModelData(
                    "find_near_city_id", prospect.get("city_id", null), lmData
                );
                this.citystateNear.textCombined["lookupModelData"] = [lmData];
                this.citystateNear["_lookupModelDataForUpdate"] = lmData;
                this.citystateNear.textCombined.text = CityUtil.formatCityStateZip(
                    lmData.getString("name"), lmData.getString("state_id"), lmData.getString("zip_code")
                );
            }
        });
    }
}